import { useAuth } from 'context/auth'

export const AccessControl = ({
  allowedPrivileges = [],
  children,
  renderNoAccess
}) => {
  const { hasAnyPrivileges } = useAuth()

  if (hasAnyPrivileges(allowedPrivileges)) {
    return children
  }

  if (renderNoAccess != null) {
    return renderNoAccess()
  }
  return null
}
